import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import pic1 from "../cover1.png";

export const HomeCarousel = props => {
  {
    return (
      <Carousel showThumbs={false} showStatus={false}>
        <div>
          <img src={pic1} />
        </div>
      </Carousel>
    );
  }
};
